import IconHOC from '../IconHOC';
import { ReactComponent as SaveIcon } from './save.svg';

export const Save = IconHOC(SaveIcon);
